export default {
  "nav.home": "Accueil",
  "nav.article": "Guide USFans",
  "nav.categories": "Catégories",
  "nav.faq": "FAQ",
  "nav.guides": "Guides",
  "nav.shoppingGuide": "Guide d'achat",
  "nav.openSpreadsheet": "USFans Spreadsheet",

  "lang.label": "Langue",

  "cta.exploreSpreadsheet": "Explorer USFans Spreadsheet",
  "cta.buyNow": "Acheter maintenant",
  "cta.visitMain": "Visiter le site principal",
  "cta.browseGuides": "Parcourir les guides USFans",
  "cta.readArticle": "Lire le guide complet",
  "cta.openSpreadsheet": "Ouvrir USFans Spreadsheet",
  "cta.backHome": "Retour à l'accueil",

  "categories.title": "Parcourir par catégorie",
  "categories.subtitle": "Accédez directement à une catégorie de produits sur le site principal",
  "categories.selectLabel": "Choisissez une catégorie",
  "categories.placeholder": "Sélectionnez une catégorie pour continuer",
  "categories.all": "Toutes les catégories",

  "categories.shoes": "Chaussures",
  "categories.hoodies": "Hoodies/Pulls",
  "categories.tshirts": "T-shirts",
  "categories.jackets": "Vestes",
  "categories.pants": "Pantalons/Shorts",
  "categories.headwear": "Couvre-chefs",
  "categories.sets": "Ensembles",
  "categories.underwear": "Sous-vêtements",
  "categories.jersey": "Maillots",
  "categories.accessories": "Accessoires",
  "categories.bags": "Sacs",
  "categories.belts": "Ceintures",
  "categories.perfumes": "Parfums",
  "categories.other": "Autres articles",

  "footer.tagline": "Un centre de ressources indépendant pour explorer USFans Spreadsheet et ses guides associés.",
  "footer.disclaimer": "USFansLink.wiki est une ressource d'information indépendante et n'est pas nécessairement affiliée ni approuvée par USFans.",
  "footer.quickLinks": "Liens rapides",
  "footer.categories": "Catégories",
  "footer.resources": "Ressources",
  "footer.language": "Langue",
  "footer.rights": "Tous droits réservés.",
  "footer.about": "À propos",
  "footer.disclaimerLink": "Avertissement",
  "footer.safety": "Centre de sécurité",
};